"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const get_1 = __importDefault(require("lodash/get"));
const map_1 = __importDefault(require("lodash/map"));
const getOffDays_1 = __importDefault(require("../getOffDays"));
const getOnDays_1 = __importDefault(require("../getOnDays"));
const getTimingSummary_1 = __importDefault(require("../getTimingSummary"));
/**
 * Returns the holidays list
 * @param {Array} holidays
 * @returns {Date[]}
 */
const getSpecialTiming = (specialTimings) => {
    return (0, map_1.default)(specialTimings, (specialDay) => {
        const timings = (0, get_1.default)(specialDay, 'timings', []);
        const startDate = (0, get_1.default)(specialDay, 'startDate');
        const endDate = (0, get_1.default)(specialDay, 'endDate');
        return {
            id: (0, get_1.default)(specialDay, 'id', 0),
            isValid: (0, get_1.default)(specialDay, 'isValid', false),
            timings: (0, getTimingSummary_1.default)(timings),
            branchId: (0, get_1.default)(specialDay, 'branchId'),
            startDate: (0, date_fns_1.parse)(startDate, 'dd-MM-yyyy', new Date()),
            endDate: (0, date_fns_1.parse)(endDate, 'dd-MM-yyyy', new Date()),
            onDays: (0, getOnDays_1.default)(timings),
            offDays: (0, getOffDays_1.default)(timings),
        };
    });
};
exports.default = getSpecialTiming;
